/**
 * Size limits for uploads, shared by every upload surface so the frontend and the
 * backend never disagree about what is acceptable.
 */

import { isClientCompressibleImage } from "./imageCompression";

/**
 * Hard ceiling enforced by the backend (`createFileLog` in file.service.ts).
 * This applies to the bytes that actually arrive there - i.e. after client-side
 * compression.
 */
export const MAX_UPLOAD_SIZE = 20 * 1024 * 1024;

/**
 * Ceiling for images *before* compression. Generous because a 40MB source photo
 * leaves the browser at roughly 1MB; the limit exists only to stop a pathological
 * file from locking up the canvas encoder.
 */
export const MAX_IMAGE_SOURCE_SIZE = 60 * 1024 * 1024;

/** Whether this file may be added to an upload batch at all. */
export const isFileWithinUploadLimits = (file: File): boolean =>
  isClientCompressibleImage(file)
    ? file.size <= MAX_IMAGE_SOURCE_SIZE
    : file.size <= MAX_UPLOAD_SIZE;

export { isClientCompressibleImage };
